import { spanishMasculineFields } from "../../const/formFieldName";
var rules = {
    required: "Este es un campo obligatorio.",
    invalidField: function (fieldName) {
        if (spanishMasculineFields.includes(fieldName)) {
            return "Por favor, ingrese un ".concat(fieldName, " v\u00E1lido.");
        }
        return "Por favor, ingrese una ".concat(fieldName, " v\u00E1lida.");
    },
    invalidCharacters: function (fieldName, characters) {
        return "Los valores aceptados de ".concat(fieldName, " son: ").concat(characters, ".");
    },
    range: function (min, max) {
        return "Por favor, ingrese entre ".concat(min, " y ").concat(max, " caracteres.");
    },
};
var spanishProfileTranslation = {
    labels: {
        title: "Administración de perfil",
        header: "Administre la información personal de sus cuentas.",
        multiaccount: "¿Desea aplicar cambios a otras cuentas?",
        manage: "Administre la información personal de sus cuentas.",
        accountselect: "Seleccione la Cuenta",
        account: "Cuenta que termina en",
        loan: "Préstamo que termina en",
        name: "Nombre de Cliente",
        select: "Seleccionar la Cuenta",
        address: "Dirección",
        phone: "Números de Teléfono",
        mobile: "Número de Teléfono Celular",
        business: "Número de Teléfono de Negocio",
        home: "Número de Teléfono Residencial",
        callAuth: "Usted autoriza a Synchrony Bank para que se ponga en contacto con usted a través de cada número de teléfono que proporcionó. Al proporcionar un número de teléfono celular y/o una dirección de correo electrónico, usted acepta recibir novedades e información sobre la cuenta, incluso mensajes de texto de Synchrony Bank. Pueden aplicarse las tarifas estándar de mensajes de texto. Usted también otorga su consentimiento a Synchrony Bank (y a cualquier otro propietario o encargado de brindar el servicio de su cuenta) para que se pongan en contacto con usted respecto a su cuenta mediante el uso de toda la información de contacto o los números de teléfono móviles que proporcione. Además, otorga su consentimiento para que se use cualquier sistema telefónico de marcado automático, de voz artificial o mensaje de voz pregrabado cuando se comuniquen con usted, aunque su plan telefónico le cobre la llamada.",
        mailingAddress: "Dirección Postal",
        email: "Dirección de Correo Electrónico",
        street2: "Dirección Postal 2",
        primaryAddress: "Dirección Principal",
        alerts: "Las alertas, las notificaciones, los mensajes importantes, etc. se le enviarán a esta dirección.",
        street: "Dirección Postal",
        zipCode: "Código Postal",
        city: "Ciudad",
        state: "Estado",
        income: "Ingresos",
        annualIncome: "Ingresos Netos Anuales",
        accountsMessage: "¿Desea aplicar cambios a otras cuentas?",
    },
    actions: {
        yes: "Sí",
        no: "No",
        edit: "EDITAR INFORMACIÓN",
        saveChanges: "GUARDAR CAMBIOS",
        cancel: "CANCELAR",
        close: "CERRAR",
    },
    forms: {
        labels: {
            success: "Actualizado correctamente.",
        },
        tooltips: {
            annualIncome: 'Sus "Ingresos Netos" incluyen lo que gana, o lo que razonablemente espera ganar, teniendo en cuenta empleo, inversiones, retiro, beneficios del seguro social y asistencia pública. También puede incluir dinero que alguien le deposita de manera regular en su cuenta (individual o conjunta) y el monto que tiene disponible para gastar de sus activos. Si es mayor de 21 años, también puede incluir el monto del ingreso de otra persona que se utiliza regularmente para pagar sus gastos. No es necesario incluir la cuota alimenticia, la manutención de menores ni los ingresos de manutención por separación judicial, salvo que dependa de estos para recibir el crédito. Residentes de WI Solamente: Si esta es una cuenta individual, incluya también los ingresos de su cónyuge.',
        },
        errors: {
            page: {
                notAllProfilesUpdated: "No se actualizaron todos los perfiles en este momento. Por favor vuelva a seleccionarlos e intente nuevamente.",
                api: "No se guardó su información actualizada en este momento. Por favor, intente nuevamente.",
                invalid_data: "Los datos proporcionados son inválidos.",
                phone: "Se necesita al menos un número de teléfono.",
                userDeclined: "Se debe verificar su identidad antes de hacer modificaciones en la información de su perfil.",
                invalidScope: "Esta cuenta no tiene los privilegios necesarios para hacer Step Up",
                accessDenied: "No pudimos verificar su identidad. No se puede actualizar su perfil en este momento.",
                serverError: "Estamos experimentando problemas técnicos y no podemos actualizar su perfil en estos momentos. Por favor, intente nuevamente más tarde.",
            },
            invalid_data: {
                zipCode: "Código postal inválido.",
            },
            rules: {
                required: rules.required,
                phone: rules.invalidField("número de teléfono"),
                zip: rules.invalidField("código postal"),
            },
            addr_line1: {
                invalid_schema: rules.invalidField("dirección"),
                required: rules.required,
            },
            addr_line2: {
                invalid_schema: rules.invalidField("dirección"),
            },
            city: {
                range_length: rules.range(2, 18),
                invalid_schema: rules.invalidField("ciudad"),
            },
            state: {
                required: rules.required,
            },
            zipCode: {
                char_length: "Por favor, ingrese 5 dígitos.",
                invalid_schema: rules.invalidField("código postal"),
            },
            email: {
                invalid_chars: "Por favor, ingrese una dirección de correo electrónico válida.",
            },
            phone: {
                required_length: "Por favor, ingrese 10 dígitos.",
                alerts: "Se necesita un número de celular para la inscripción a las alertas.",
            },
            income: {
                invalid_length: "El valor no puede exceder $9,999,999",
                invalid_schema: rules.invalidField("ingreso"),
            },
        },
    },
    incomeCapture: {
        modal: {
            header: {
                text: "Actualice Su Ingreso",
            },
            footer: {
                saveButton: "Actualizar Ingreso",
                skipButton: "Omitir la Actualización del Ingreso",
            },
            content: {
                title: "Actualice su Ingreso en su Tarjeta {{cardName}}",
                subtitle: "Por favor, tómese un momento y actualice su ingreso neto anual para que podamos considerarlo para futuros aumentos del límite de crédito.",
                body: {
                    firstParagraph: "Sus “Ingresos Netos” incluyen lo que gana o lo que razonablemente espera ganar por su empleo, inversiones, jubilación, beneficios del seguro social y asistencia pública. También puede incluir el dinero que otra persona deposita regularmente en su cuenta (individual o conjunta) y el monto que tiene disponible para gastar de sus activos. Si usted tiene 21 años o más, también podrá incluir el monto de los ingresos de alguna otra persona que se use periódicamente para pagar sus gastos.",
                    secondParagraph: "No es necesario incluir la cuota alimentaria, la manutención de menores ni los ingresos de manutención por separación judicial, salvo que se dependa de estos para el crédito.",
                    thirdParagraph: "Únicamente: Si esta es una cuenta individual, por favor también incluya los ingresos de su cónyuge.",
                    WIResidents: "Residentes de Wisconsin (WI): ",
                },
                checkbox: "Solicitarlo en todas las cuentas",
            },
        },
        error: {
            default: {
                title: "Estamos teniendo dificultades técnicas",
                subtitle: "Por favor, intente nuevamente más tarde",
            },
            message: "Ingrese su ingreso neto anual",
        },
        success: {
            title: "El ingreso se ha actualizado",
            subtitle: "¡Gracias!",
        },
    },
    errorPage: {
        title: "No están Disponibles los Perfiles de la Cuenta",
        description: "Tenemos problemas para recuperar la información de perfil de sus cuentas.",
        tryAgain: "Por favor, intente nuevamente más tarde.",
    },
};
export default spanishProfileTranslation;
